function isCaptchaChecked() {
  // return grecaptcha && grecaptcha.getResponse().length !== 0;
  let value = document.querySelector('#captcha-container input[name="smart-token"]').value
  if (value == '') {
    return false
  }
  return true
}

const validatePhoneNumber = (phone_number) => {
  if (phone_number.length > 0) {
    return true
  }
  return false
}

const RequestHelpFormSubmit = (e) => {
  let phone_number = RequestHelpPhone.value
  console.log(isCaptchaChecked())
  console.log(validatePhoneNumber(phone_number))
  if (isCaptchaChecked() && validatePhoneNumber(phone_number)) {
    RequestHelpLoader.classList.remove('d-none')
    return true
  }
  RequestHelpLoader.classList.add('d-none')
  RequestHelpErr.classList.remove('d-none')
  e.preventDefault()
  return false
}

document.getElementById('RequestHelpForm').addEventListener('submit', RequestHelpFormSubmit)

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});

var last_scroll_top = 0;

let Header = document.getElementById('Header');
if (Header != undefined) {
  window.addEventListener('scroll', function() {
    let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
    if (scroll_top > 200) {
      if (scroll_top < last_scroll_top) {
        Header.classList.remove('scrolled-down');
        Header.classList.add('scrolled-up');
      }
      else {
        Header.classList.remove('scrolled-up');
        Header.classList.add('scrolled-down');
      }
      last_scroll_top = scroll_top;
    }
  });
}
